import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  accessToken?: string;
  userId?: string;
  refreshToken?: string;
  isLogin?: boolean;
}

const initialState: AuthState = {
  accessToken: '',
  userId: '',
  refreshToken: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<any>) => {
      state.accessToken = action?.payload.accessToken;
    },
    clearAccessToken: (state) => {
      state.accessToken = undefined;
    },
    setIsLogin: (state, value: PayloadAction<any>) => {
      state.isLogin = value.payload;
    },
  },
});

export const { setAccessToken, clearAccessToken, setIsLogin } = authSlice.actions;

export default authSlice.reducer;
